import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import PropTypes from 'prop-types';
import withStyles from '@mui/styles/withStyles';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import TextField from '@mui/material/TextField';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import { green } from '@mui/material/colors';

const styles = theme => ({
    root: {
        margin: 0,
        padding: 0
    },
    buttonControl: {
        margin: '8px 0px 8px 16px'
    },
    chip: {
        margin: '8px 8px 8px 0px'
    },
    listElement: {
        margin: 10,
        padding: '4px 8px 4px 8px'
    },
    bold: {
        fontWeight: theme.typography.fontWeightMedium
    },
    actionContainer: {
        display: 'flex',
        width: '100%',
        flexDirection: 'row-reverse',
        marginBottom: theme.spacing(3)
    },
    paper: {
        padding: theme.spacing(2),
        marginBottom: theme.spacing(3)
    },
    buttonProgress: {
        color: green[500],
        position: 'absolute',
        top: '50%',
        left: '50%',
        marginTop: -12,
        marginLeft: -12
    },
    link: theme.style.link,
    button: {
        margin: theme.spacing(1)
    }
});

class AdministrationRepresentant extends React.Component {
    render() {
        let { classes, representant, isPatching, onClickSave, onChange } = this.props;

        if (!representant) {
            return null;
        }

        return (
            <React.Fragment>
                <div className={classes.root}>
                    <Helmet>
                        <title>{`Representant : ${representant.code}`}</title>
                    </Helmet>

                    <Typography gutterBottom variant="h5">
                        Édition du représentant : {representant.code} - {representant.nom}
                    </Typography>

                    <Breadcrumbs separator="›" arial-label="breadcrumb">
                        <Link to={`/administration/representants/`} className={classes.link}>
                            <Typography variant="button">
                                Representants
                            </Typography>
                        </Link>

                        <Typography color="textPrimary">{representant.code} - {representant.nom}</Typography>
                    </Breadcrumbs>

                    <Paper className={classes.paper}>
                        <Typography gutterBottom variant="h6">
                            Paramètres
                        </Typography>

                        <TextField
                            className={classes.marginLeft}
                            name='pctJokerFraisRetour'
                            label="Avoir joker"
                            value={representant.pctJokerFraisRetour}
                            onChange={onChange}
                        />
                    </Paper>

                    <div className={classes.actionContainer} >
                        <Link to="/administration/representants">
                            <Button
                                className={classes.buttonControl}
                                disabled={false}
                                onClick={onClickSave}
                                variant="contained"
                                color="secondary"
                            >
                                Enregistrer
                                    {isPatching === true && <CircularProgress size={24} className={classes.buttonProgress} />}
                            </Button>
                        </Link>
                        <Link to="/administration/representants">
                            <Button className={classes.buttonControl} color="primary" >
                                Annuler
                            </Button>
                        </Link>
                    </div>
                </div>
            </React.Fragment>
        );
    }
}

AdministrationRepresentant.propTypes = {
    classes: PropTypes.object.isRequired,
    representant: PropTypes.object
};

export default withStyles(styles)(AdministrationRepresentant);